(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["guia-glossario"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.glossaryReady==="true") return;
    root.dataset.glossaryReady="true";
    var input=root.querySelector("[data-glossary-search]");
    var status=root.querySelector("[data-glossary-status]");
    var items=Array.prototype.slice.call(root.querySelectorAll("[data-glossary-item]"));
    if(!input || !status) return;
    input.addEventListener("input",function(){
      var query=input.value.trim().toLocaleLowerCase("pt-BR");
      var visible=0;
      items.forEach(function(item){
        var match=!query || item.textContent.toLocaleLowerCase("pt-BR").indexOf(query)>-1;
        item.hidden=!match;
        if(match) visible+=1;
      });
      status.textContent=query ? visible+" termo(s) encontrado(s)" : "";
    });
  }
  function initAll(scope){
    if(scope.matches && scope.matches("[data-guide-glossary]")) init(scope);
    Array.prototype.forEach.call(scope.querySelectorAll ? scope.querySelectorAll("[data-guide-glossary]") : [],init);
  }
  initAll(document);
  document.addEventListener("shopify:section:load",function(event){initAll(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
